
import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";
import { Helmet } from "react-helmet-async";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname,
      {
        fullUrl: window.location.href,
        hasHash: window.location.hash ? true : false,
        hashLength: window.location.hash.length
      }
    );
  }, [location.pathname]);

  return (
    <>
      <Helmet>
        <title>Página não encontrada | Justiçai Assistente Jurídico</title>
        <meta name="description" content="A página solicitada não foi encontrada. Volte para a página inicial do Justiçai, seu assistente jurídico com IA." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center max-w-md p-6">
          <h1 className="text-4xl font-bold mb-4 text-primary">404</h1>
          <p className="text-xl text-foreground mb-6">Página não encontrada</p>
          <p className="text-muted-foreground mb-8">
            A página que você está procurando não existe ou pode ter sido movida.
            {window.location.hash && window.location.hash.length > 0 && (
              <span className="block mt-2 text-sm">
                Detectamos parâmetros de autenticação no URL. Se você acabou de fazer login, 
                por favor tente novamente ou contacte o suporte.
              </span>
            )}
          </p>
          
          <div className="space-y-4">
            <Button asChild className="gap-2">
              <Link to="/casos">
                <Home size={16} />
                Ir para Casos
              </Link>
            </Button>
            
            <p className="text-sm text-muted-foreground mt-8">
              Veja também:
            </p>
            
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/casos" className="text-primary hover:underline">
                  Casos (página principal)
                </Link>
              </li>
              <li>
                <Link to="/plans" className="text-primary hover:underline">
                  Planos e preços
                </Link>
              </li>
              <li>
                <a href="mailto:suporte@chat.adv.br" className="text-primary hover:underline">
                  Contato com suporte
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;
